import {
  ImageBackground,
  TouchableOpacity,
  Text,
  StyleSheet,
  ImageSourcePropType,
  StyleProp,
  ImageStyle,
  Image,
  View,
} from "react-native";
import { useDevice } from "../../../utils/hooks/useDevice";

export const ButtonCard = ({
  label,
  onPress,
  activeImage,
  inactiveImage,
  active,
  icon,
  iconStyle,
  minWidth = 100,
  labelStyle,
}: {
  label: string;
  onPress: () => void;
  activeImage: any;
  inactiveImage: any;
  active?: boolean;
  icon?: ImageSourcePropType;
  iconStyle?: StyleProp<ImageStyle>;
  minWidth?: number;
  labelStyle?: StyleProp<ImageStyle>;
}) => {
  const { isTablet, isDesktop, isSm, isMobile } = useDevice();

  const isPortrait = isMobile || isTablet || isSm;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.buttonContainer,
        isPortrait ? { flex: 1, minWidth } : { marginHorizontal: -3, minWidth },
      ]}
    >
      <ImageBackground
        source={active ? activeImage : inactiveImage}
        style={[
          styles.background,
          isPortrait
            ? { width: "100%", height: 50 }
            : { width: 190, height: 50 },
        ]}
        imageStyle={[styles.bgImage, { resizeMode: "stretch" }]}
      >
        <View style={[styles.content, { minHeight: 70 }]}>
          <Image
            source={icon}
            style={[styles.icon, iconStyle]}
            resizeMode="contain"
          />
          <Text
            style={[
              styles.label,
              active && styles.activeLabel,
              labelStyle,
              { fontSize: isPortrait ? 12 : 14 },
            ]}
          >
            {label}
          </Text>
        </View>
      </ImageBackground>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  background: {
    // width: "100%",
    // height: 50,
    justifyContent: "center",
    alignItems: "center",
    // display: "flex",
    // flexDirection: "row",
    // minWidth: 200,
  },
  label: {
    color: "#FFEAA0",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "center",
    paddingBottom: 4,
  },
  activeLabel: {
    // color: "#000",
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  icon: {
    // width: 20,
    height: 20,
    // marginRight: 8,
  },
  bgImage: {
    borderRadius: 10,
  },
});
